import { Flex, styled, Radius } from '@chilipiper/design-system'
interface BackgroundProps {
  bgColor: string
}

interface ImageProps {
  borderRadius?: Radius
  size?: number
}

export const StyledBackground = styled(Flex)<BackgroundProps>`
  background: ${props => props.bgColor};
  width: 100%;
  height: 100%;
  background-size: cover;
`

export const StyledImage = styled.img<ImageProps>`
  object-fit: cover;
  width: ${props => (props.size ? props.theme.sizes[props.size] : undefined)};
  height: ${props => (props.size ? props.theme.sizes[props.size] : undefined)};
  border-radius: ${props =>
    props.borderRadius ? props.theme.radii[props.borderRadius] : undefined};
`
